import React from "react"
import { useSuspenseQuery } from "@tanstack/react-query"
import { pick } from "lodash"

import { MenuAppInstance } from "@/entities/app/menu/menu.types"
import DesignDAO from "@/entities/design/design.dao"
import { DesignFindFiltersDTO } from "@/entities/design/design.dto"
import Notice from "@/shared/components/extrinsic/Notice/Notice"
import useSearch from "@/utils/hooks/useSearch"

import MenuDesignPreviews, { MenuDesignPreviewsProps } from "./MenuDesignPreviews"



const designDao = new DesignDAO


interface MenuDesignPreviewsContainerProps extends Pick<MenuDesignPreviewsProps, "selected" | "onSelect"> {
  app: MenuAppInstance
  filters?: DesignFindFiltersDTO
  onRefetch?: (refetch: () => Promise<any>) => void
}

function MenuDesignPreviewsContainer(props: MenuDesignPreviewsContainerProps) {
  const seek = React.useMemo(
    () => ({ ...props.filters, ...pick(props.app, "locationId", "companyId") }),
    [props.filters, props.app]
  )
  const search = useSearch(seek?.name)

  const { data: designs, refetch } = useSuspenseQuery({
    queryFn: () => designDao.findAll(seek),
    queryKey: ["designs", seek]
  })

  React.useEffect(() => {
    props.onRefetch?.(refetch)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refetch])

  if (designs.length === 0) {
    return <Notice icon="info">You do not have any designs yet!</Notice>
  }

  return (
    <MenuDesignPreviews companyId={props.app.companyId} designs={designs} selected={props.selected} onSelect={props.onSelect} highlight={search.highlight} />
  )
}

export default MenuDesignPreviewsContainer
